import { render, staticRenderFns } from "./relation_tags_menu.vue?vue&type=template&id=672abc49"
import script from "./relation_tags_menu.vue?vue&type=script&lang=js"
export * from "./relation_tags_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports